import { i18n } from '@/i18n';
import useOrderService from '@/services/order/OrderService';

export function getTempWorkerAsideNavigation (): Armado.AsideNavigationItems {
	return {
		'Profile': [
			{
				label: i18n.global.t('common.asideMenu.profile.informations'),
				to: { name: 'UserProfileInformations' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.documents'),
				to: { name: 'UserProfileTempWorkerDocuments' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.agencies'),
				to: { name: 'UserProfileCompanies' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.availabilities'),
				to: { name: 'UserProfileAvailabilities' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.account'),
				to: { name: 'UserProfileAccount' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.devices'),
				to: { name: 'UserProfileDevices' },
			},
		],
	};
}

export function getClientAsideNavigation (): Armado.AsideNavigationItems {
	return {
		'Profile': [
			{
				label: i18n.global.t('common.asideMenu.profile.informations'),
				to: { name: 'UserProfileInformations' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.companies'),
				to: { name: 'UserProfileCompanies' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.account'),
				to: { name: 'UserProfileAccount' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.devices'),
				to: { name: 'UserProfileDevices' },
			},
		],
		'Organization': [
			{
				label: i18n.global.t('common.asideMenu.organization.pendingActions'),
				to: { name: 'OrganizationPendingActions' },
			},
			{
				label: i18n.global.t('common.asideMenu.organization.fusionRequests'),
				to: { name: 'OrganizationFusionRequests' },
			},
			{
				label: i18n.global.t('common.asideMenu.organization.usage'),
				to: { name: 'OrganizationUsage' },
			},
		],
		'OrderDetail': [
			{
				label: i18n.global.t('common.asideMenu.orderDetail.orderTracking'),
				to: { name: 'OrderDetailsStatus' },
			},
			{
				label: i18n.global.t('common.asideMenu.orderDetail.orderDetail'),
				to: { name: 'OrderDetailsRecap' },
			},
			{
				label: i18n.global.t('common.asideMenu.orderDetail.scheduleDetail'),
				callback: () => { useOrderService().openScheduleRecapModalAsync() },
			},
			{
				label: i18n.global.t('common.asideMenu.orderDetail.relatedContracts'),
				to: { name: 'OrderDetailsClientContract' },
			},
		],
	};
}

export function getAgencyAsideNavigation (): Armado.AsideNavigationItems {
	return {
		'Profile': [
			{
				label: i18n.global.t('common.asideMenu.profile.informations'),
				to: { name: 'UserProfileInformations' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.myAgencies'),
				to: { name: 'UserProfileCompanies' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.account'),
				to: { name: 'UserProfileAccount' },
			},
			{
				label: i18n.global.t('common.asideMenu.profile.devices'),
				to: { name: 'UserProfileDevices' },
			},
		],
		'CgvCtt': [
			{
				label: i18n.global.t('common.asideMenu.cgvCtt.current'),
				to: {
					name: 'CgvCtt',
					params: { status: 'en-cours' },
				},
			},
			{
				label: i18n.global.t('common.asideMenu.cgvCtt.upcoming'),
				to: {
					name: 'CgvCtt',
					params: { status: 'a-venir' },
				},
			},
			{
				label: i18n.global.t('common.asideMenu.cgvCtt.past'),
				to: {
					name: 'CgvCtt',
					params: { status: 'passees' },
				},
			},
		],
		'Settings': [
			{
				label: i18n.global.t('common.asideMenu.settings.reminders'),
				to: { name: 'SettingsReminders' },
			},
			{
				label: i18n.global.t('common.asideMenu.settings.bills'),
				to: { name: 'SettingsBills' },
			},
			{
				label: i18n.global.t('common.asideMenu.settings.advancedPayment'),
				to: { name: 'SettingsAdvancedPayment' },
			},
			{
				label: i18n.global.t('common.asideMenu.settings.legalRepresentative'),
				to: { name: 'SettingsDelegates' },
			},
			{
				label: i18n.global.t('common.asideMenu.settings.notifications'),
				to: { name: 'SettingsNotification' },
			},
		],
		'Toolbox': [
			{
				label: i18n.global.t('common.asideMenu.toolbox.talentPool'),
				to: { name: 'ToolboxTalentPool' },
			},
			{
				label: i18n.global.t('common.asideMenu.toolbox.taskTemplate'),
				to: { name: 'ToolboxTaskTemplate' },
			},
			{
				label: i18n.global.t('common.asideMenu.toolbox.jobDescription'),
				to: { name: 'ToolboxJobDescription' },
			},
		],
		'Organization': [
			{
				label: i18n.global.t('common.asideMenu.organization.pendingActions'),
				to: { name: 'OrganizationPendingActions' },
			},
			{
				label: i18n.global.t('common.asideMenu.organization.fusionRequests'),
				to: { name: 'OrganizationFusionRequests' },
			},
			{
				label: i18n.global.t('common.asideMenu.organization.usage'),
				to: { name: 'OrganizationUsage' },
			},
		],
		'OrderDashboard': [
			{
				label: i18n.global.t('admin.asideMenu.orderDashboard.dashboard'),
				to: { name: 'OrderDashboardOverView' },
			},
			{
				label: i18n.global.t('admin.asideMenu.orderDashboard.tempWorkerManagement'),
				to: { name: 'OrderDashboardGestionTempWorker' },
			},
			{
				label: i18n.global.t('admin.asideMenu.orderDashboard.statistics'),
				to: { name: 'OrderDashboardStats' },
			},
			{
				label: i18n.global.t('admin.asideMenu.orderDashboard.agencySettings'),
				to: { name: 'OrderDashboardAgencyParams' },
			},
		],
		'OrderDetail': [
			{
				label: i18n.global.t('common.asideMenu.orderDetail.candidateTracking'),
				to: { name: 'OrderDetailsPipeline' },
			},
			{
				label: i18n.global.t('common.asideMenu.orderDetail.orderLife'),
				to: { name: 'OrderDetailsStatus' },
			},
			{
				label: i18n.global.t('common.asideMenu.orderDetail.orderDetail'),
				to: { name: 'OrderDetailsRecap' },
			},
			{
				label: i18n.global.t('common.asideMenu.orderDetail.scheduleDetail'),
				callback: () => { useOrderService().openScheduleRecapModalAsync() },
			},
			{
				label: i18n.global.t('common.asideMenu.orderDetail.history'),
				to: { name: 'OrderDetailsHistory' },
			},
			{
				label: i18n.global.t('common.asideMenu.orderDetail.relatedContracts'),
				to: { name: 'OrderDetailsContracts' },
			},
		],
	};
}
